import React from 'react';

/**
 * Loading spinner with optional message
 * 
 * Design: Matches Ministry of Wine design system
 * - Spinner: secondary-500 (#34a853 green)
 * - Text: neutral-600 (gray)
 */
export const LoadingSpinner: React.FC<{ message?: string }> = ({ message = 'Loading...' }) => {
  return (
    <div className="flex flex-col items-center justify-center min-h-[400px]">
      <div className="relative">
        {/* Background circle */}
        <div className="h-12 w-12 rounded-full border-4 border-neutral-200"></div>
        {/* Spinning circle */}
        <div className="absolute top-0 h-12 w-12 rounded-full border-4 border-secondary-500 border-t-transparent animate-spin"></div>
      </div>
      {message && (
        <p className="mt-4 text-sm text-neutral-600 font-medium">{message}</p>
      )}
    </div>
  );
};
